<template>
  <div>
    <div class="pdf-sheet-plugin__selector">
      <div class="pdf-sheet-plugin__selector--label">{{ options.locale.Orientation }}:</div>
      <div class="pdf-sheet-plugin__selector--widget">
        <v-btn-toggle v-model="toggle_orientations" mandatory @change="onPageOrientationChange">
          <v-btn
            text
            small
            v-for="o in options.orientations"
            :key="o.name"
            v-html="o.ico"
            class="pdf-sheet-plugin__selector--choice px-2"
          >
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>

    <div class="pdf-sheet-plugin__selector">
      <div class="pdf-sheet-plugin__selector--label">{{ options.locale.Size }}:</div>
      <div class="pdf-sheet-plugin__selector--widget">
        <v-btn-toggle v-model="toggle_page_formats" @change="onPageFormatChange">
          <v-btn
            text
            small
            v-for="o in options.pageFormats"
            :key="o.name"
            class="pdf-sheet-plugin__selector--choice px-2"
          >
            {{ o.name }}
          </v-btn>
        </v-btn-toggle>
        <div class="pdf-sheet-plugin__selector--inputXY">
          <!-- eslint-disable-next-line vue/no-mutating-props -->
          <input v-model="options.sizeX" class="pdf-sheet-plugin__selector--input-size" @change="onSizeChange" />
          <div class="pdf-sheet-plugin__selector--separator">x</div>
          <!-- eslint-disable-next-line vue/no-mutating-props -->
          <input v-model="options.sizeY" class="pdf-sheet-plugin__selector--input-size" @change="onSizeChange" />
          <span class="pdf-sheet-plugin__selector--unit">{{ options.locale.mm }}</span>
        </div>
      </div>
    </div>

    <div class="pdf-sheet-plugin__selector">
      <div class="pdf-sheet-plugin__selector--label">{{ options.locale.Scale }}:</div>
      <div class="pdf-sheet-plugin__selector--widget">
        <v-btn-toggle v-model="toggle_page_scales" @change="onScaleToggleChange">
          <v-btn
            text
            small
            v-for="o in options.exampleScales"
            :key="o.name"
            class="pdf-sheet-plugin__selector--choice px-2"
          >
            {{ o.name }}
          </v-btn>
        </v-btn-toggle>
        <div class="pdf-sheet-plugin__selector--inputXY">
          <input v-model="scale.size" class="pdf-sheet-plugin__selector--input" @change="onScaleChange" />
          <span class="pdf-sheet-plugin__selector--unit">{{ options.locale.scale_unit }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: ['options'],
  data() {
    const orientation = this.options.orientations.map((x) => x.name).indexOf(this.options.orientation);

    const format = this.getFormat();
    const scale = this.options.exampleScales.find((x) => x.size === this.options.scale);
    return {
      toggle_orientations: orientation,
      toggle_page_formats: format,
      toggle_page_scales: this.options.exampleScales.indexOf(this.options.scale),
      scale: scale || { name: '', size: this.options.scale },
    };
  },

  computed: {
    size() {
      return [this.options.sizeX, this.options.sizeY];
    },
  },

  watch: {
    size() {
      this.onSizeChange();
    },
  },

  methods: {
    onPageOrientationChange(i) {
      const orientation = this.options.orientations[i];
      if (orientation) {
        this.options.orientation = orientation.name;
        this.emitChange();
      }
    },

    onPageFormatChange(a) {
      const format = this.options.pageFormats[a];
      if (format) {
        this.options.sizeX = format.size[0];
        this.options.sizeY = format.size[1];
        // this.emitChange();
      }
    },

    onSizeChange(a) {
      const size = [this.options.sizeX, this.options.sizeY];
      if (this.options.orientation !== 'album') {
        // size.reverse();
      }
      this.options.size = size.map((x) => Number(x));
      this.toggle_page_formats = this.getFormat();

      this.emitChange({ size });
    },

    getFormat() {
      return this.options.pageFormats.findIndex((x) => {
        const { size } = this.options;
        if (typeof size === 'string') {
          return x.name === size;
        }
        return JSON.stringify(x.size) === JSON.stringify(size);
      });
    },

    setSize(value) {
      if (value) {
        return value.split('-').map((x) => parseInt(x, 10));
      }
      return [0, 0];
    },

    onScaleToggleChange(i) {
      const scale = this.options.exampleScales[i];
      if (scale) {
        this.scale = scale;
        this.emitChange();
      }
    },

    onScaleChange(e) {
      const index = this.options.exampleScales.findIndex((x) => x.size === Number(e.target.value));
      this.toggle_page_scales = index;
      this.emitChange();
    },

    emitChange({ size } = {}) {
      size = size || [this.options.sizeX, this.options.sizeY];
      // TODO: use parent is not good; find another way to emit event outside
      this.$parent.$emit('change', {
        scale: this.scale.size,
        orientation: this.options.orientation,
        size,
      });
    },
  },
};
</script>
